import React from 'react';
import WithFlowField from '../WithFlowField';
import FlowFieldInput from '../fields/FlowFieldInput';
import FlowFieldChoice from '../fields/FlowFieldChoice';
import FlowFieldHidden from '../fields/FlowFieldHidden';
import FlowFieldSelect from '../fields/FlowFieldSelect';
import FlowFieldLicensePlate from "../fields/FlowFieldLicensePlate";
import FlowFieldDatePicker from "../fields/FlowFieldDatePicker";
import FlowFieldFile from '../fields/FlowFieldFile';
import FlowFieldTextarea from '../fields/FlowFieldTextarea';
import FlowFieldSpacer from '../fields/FlowFieldSpacer';

export default class FlowRendererField extends React.Component {
    constructor(props) {
        super(props);
    }

    renderField = (field, props) => {
        const { type } = field;

        if (typeof this.props.renderField === 'function') {
            const renderOverwrite = this.props.renderField(field, props);

            if (renderOverwrite) {
                return renderOverwrite;
            }
        }

        if (type === 'choice-radio') {
            return <FlowFieldChoice {...props} inputType="radio" />;
        }

        if (type === 'choice-checkbox') {
            return <FlowFieldChoice {...props} inputType="checkbox" />;
        }

        if (type === 'choice-dropdown') {
            return <FlowFieldSelect {...props} inputType="select" />;
        }

        if (type === 'file') {
            return <FlowFieldFile {...props} inputType="file" />;
        }

        if (type === 'hidden') {
            return <FlowFieldHidden {...props} inputType="hidden" />;
        }

        if (type === 'license-plate') {
            return <FlowFieldLicensePlate {...props} inputType="text" />;
        }

        if (type === 'textarea') {
            return <FlowFieldTextarea {...props} inputType="textarea" />;
        }

        if (type === 'phone') {
            return <FlowFieldInput {...props} inputType="tel" />;
        }

        if (type === 'date') {
            return <FlowFieldDatePicker {...props} />;
        }

        if (type === 'spacer') {
            return <FlowFieldSpacer {...props} />;
        }

        return <FlowFieldInput {...props} inputType={type}/>;
    }

    render() {
        const { component, fields, path, id, ...passProps } = this.props;

        return (
            <React.Fragment>
                {fields?.map((field, fieldIndex) => {
                    const fieldPath = `${path}.${fieldIndex}`;
                    const fieldId = `${id}.${fieldIndex}-${field?.name}`;

                    return (
                        <WithFlowField
                            key={fieldId}
                            path={fieldPath}
                            id={fieldId}
                            field={field}
                            component={component}
                            {...passProps}
                        >
                            {(props) => {
                                return this.renderField(field, props);
                            }}
                        </WithFlowField>
                    )
                })}

            </React.Fragment>
        );
    }
}
